export default "__VITE_ASSET__CqBWL149__"